import React, { useState, useEffect, useContext } from "react";
import { useNavigate, useParams } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import FormGenerator from "../../../core/form-generator";
import { HTTP_METHODS, invokeApi, plainApi } from "../../../utils/http-service";
import { HOSTNAME, REST_URLS } from "../../../utils/endpoints";
import { toast } from "react-toastify";
import { generateJIRPDF, JIR_CONFIG, previewPdf } from "./helper";
import { formatDate, splitFileName } from "../../../utils";
import { Box, Grid } from "@mui/material";
import { DATE_FORMATS, USER_ROLES } from "../../../utils/constants";
import FormContainer from "../../../core/form-container";
import CustomButtonComponent from "../../../core/custom-button";
import { Icon } from "@iconify/react";
import Checklist from "../../../components/checklist";
import AppContext from "../../../utils/context";

const JointInspectionReport = () => {
  const { id } = useParams();
  const { userDetails = {} } = useContext(AppContext);
  const navigate = useNavigate();
  const [formData, setFormData] = useState({});
  const [errors, setErrors] = useState({});
  const [isChecklist, setIsChecklist] = useState(false);

  const loadData = (isDownload = false) => {
    const params = isDownload ? { download: "TRUE" } : null;
    let url = `${HOSTNAME}${REST_URLS.GET_JIR_FROM_TICKET}/${id}`;
    if (userDetails.role === USER_ROLES.OEM) {
      url = `${HOSTNAME}${REST_URLS.OEM_GET_JIR_FROM_TICKET}/${id}`;
    }
    invokeApi(
      HTTP_METHODS.GET,
      url,
      null,
      params
      // isDownload ? "blob" : null
    )
      .then((res) => {
        if (res.message) {
          toast.error(res.message);
        } else {
          if (isDownload) {
            generateJIRPDF(res);
          } else {
            setFormData({
              ...res,
              dateOfInspection: formatDate(
                res.dateOfInspection,
                DATE_FORMATS["DD-MM-YYYY"]
              ),
              oem: res?.oem?.name,
            });
          }
        }
      })
      .catch((err) => console.error(err));
  };

  useEffect(() => {
    loadData();
  }, []);
  console.log(formData);
  return (
    <div className="page-body page-load">
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <div className=" view-detailed-ticket">
          <ArrowBackIcon
            sx={{ cursor: "pointer", marginRight: "20px" }}
            onClick={() => {
              navigate(-1);
            }}
          />
          <div className="border-r">
            <p className="tab-name">Complaint Handling</p>
            <p className="section-name">Joint Inspection Report</p>
          </div>
          <div>
            <p className="tab-name">Ticket ID</p>
            <p className="section-name">{id}</p>
          </div>
        </div>
        <div>
          <CustomButtonComponent
            variant="contained"
            onClick={() => previewPdf(id, userDetails, formData)}
            sx={{ mr: 4 }}
          >
            View Checklist PDF
          </CustomButtonComponent>
          <CustomButtonComponent
            variant="contained"
            onClick={() => setIsChecklist(true)}
          >
            Checklist
          </CustomButtonComponent>
          <CustomButtonComponent
            variant="contained"
            color="success"
            startIcon={
              <Icon
                icon="solar:download-bold-duotone"
                width="1.2rem"
                height="1.2rem"
                style={{ color: "white" }}
              />
            }
            onClick={() => loadData(true)}
            sx={{ mr: 6, ml: 4 }}
          >
            Download
          </CustomButtonComponent>
        </div>
      </Box>
      <FormContainer>
        <FormGenerator
          errors={errors}
          setErrors={setErrors}
          config={JIR_CONFIG}
          formData={formData}
          setFormData={setFormData}
        />
        <Grid container>
          <Grid item md={6} xs={12}>
            {" "}
            <div>
              {formData?.serviceMaintenanceRecord?.length > 0 && (
                <p className="primary-text">Service Maintenance Record</p>
              )}
              <div className="free-services">
                {formData?.serviceMaintenanceRecord?.length > 0 && (
                  <div className="service-row table-head-bg">
                    <div>Service No.</div>
                    <div>Date</div>
                    <div>Hours</div>
                  </div>
                )}

                {formData?.serviceMaintenanceRecord?.map((ele) => {
                  return (
                    <div className="service-row ">
                      <div>{ele.serviceNo}</div>
                      <span>
                        {formatDate(ele.date, DATE_FORMATS["DD-MM-YYYY"])}
                      </span>
                      <div>{ele.hours}</div>
                    </div>
                  );
                })}
              </div>
            </div>
          </Grid>
          <Grid item md={6}>
            {formData?.pastComplaints?.length > 0 && (
              <div>
                <p className="primary-text">Past Complaints</p>
                <div className="free-services">
                  {formData?.pastComplaints.length > 0 && (
                    <div className="jir-table-row-cols service-row table-head-bg">
                      <div>Complaint Reported</div>
                      <div>Date</div>
                      <div>Hours</div>
                    </div>
                  )}
                  {formData?.pastComplaints?.map((h) => {
                    return (
                      <div className="jir-table-row-cols service-row ">
                        <div>{h.complaintReported}</div>
                        <span>
                          {formatDate(h.date, DATE_FORMATS["DD-MM-YYYY"])}
                        </span>

                        <div>{h.hours}</div>
                      </div>
                    );
                  })}
                </div>
              </div>
            )}
          </Grid>
        </Grid>
        <div>
          <p>Attachments</p>
          <Box sx={{ display: "flex", gridGap: "20px" }}>
            {formData?.simpsonEngineerSign && (
              <a
                className="open-link"
                href={splitFileName(formData.simpsonEngineerSign)}
                target="_blank"
              >
                Simpson Engineer Signature
              </a>
            )}
            {formData?.oemEngineerSign && (
              <a
                className="open-link"
                href={splitFileName(formData.oemEngineerSign)}
                target="_blank"
              >
                OEM Engineer Signature
              </a>
            )}
            {formData?.photos?.length > 0 &&
              formData.photos.map((photo, index) => (
                <a
                  key={index}
                  className="open-link"
                  href={splitFileName(photo)}
                  target="_blank"
                >
                  Photo {index + 1}
                </a>
              ))}
            {formData?.videos?.length > 0 &&
              formData.videos.map((video, index) => (
                <a
                  key={index}
                  className="open-link"
                  href={splitFileName(video)}
                  target="_blank"
                >
                  Video {index + 1}
                </a>
              ))}
            {formData?.documents?.length > 0 &&
              formData.documents.map((document, index) => (
                <a
                  key={index}
                  className="open-link"
                  href={splitFileName(document)}
                  target="_blank"
                >
                  Document {index + 1}
                </a>
              ))}
          </Box>
        </div>
      </FormContainer>
      {isChecklist && (
        <Checklist setIsChecklist={setIsChecklist} ticketId={id} />
      )}
    </div>
  );
};

export default JointInspectionReport;
